import React from 'react';
import { Trans, useI18nContext } from '@ecg-marktplaats/js-react-i18n';
import { Link } from '@hz-design-system/web-ui';

import SellerItem from './SellerItem';
import { SELLER_OTHER_ITEMS_LIMIT } from '../../../../../common/constants';

import { TListingClient } from 'types/TListing';
import { TSellerOtherItem } from 'types/TSellerOtherItem';

import Classes from './SellerOtherItems.scss';

type TSellerOtherItemsProps = {
  listing: TListingClient;
  sellerOtherItems: TSellerOtherItem[];
};

const SellerOtherItems = ({ sellerOtherItems, listing }: TSellerOtherItemsProps) => {
  const { t } = useI18nContext();

  if (!sellerOtherItems?.length) {
    return null;
  }

  return (
    <div className={`block-wrapper ${Classes.root}`}>
      <div className={Classes.headerWrapper}>
        <Trans className={Classes.header} i18nKey="sellerOtherItems.header" sellerName={listing.seller.name} />
        <Trans
          className={Classes.headerShort}
          i18nKey="sellerOtherItems.headerShort"
          sellerName={listing.seller.name}
        />
        {sellerOtherItems.length === SELLER_OTHER_ITEMS_LIMIT && (
          <Link href={listing.seller.pageUrl} className={Classes.headerLink}>
            {t('sellerOtherItems.showAll')}
          </Link>
        )}
      </div>
      <div className={Classes.list}>
        {sellerOtherItems.map((item) => (
          <SellerItem className={Classes.item} item={item} key={item.itemId} />
        ))}
      </div>
    </div>
  );
};

export default SellerOtherItems;
